// extracted by mini-css-extract-plugin
module.exports = {"bylineContainer":"styles-module__bylineContainer___tLoFX","byline":"styles-module__byline___TbUzJ","bylineWrapper":"styles-module__bylineWrapper___1Nr3O"};